<template>
    <div class="coupon">
        <el-row style="margin-top:20px;">
            <el-col :span="24">
                <el-card class="box-card">
                    <el-row :gutter="15">
                        <el-col :span="1.2"
                            ><div class="grid-content bg-purple">
                                <span>优惠券名称:</span>
                            </div></el-col
                        >
                        <el-col :span="5"
                            ><div class="grid-content bg-purple">
                                <el-input v-model.trim="searchInfo.couponName" placeholder="请输入优惠券名称" clearable></el-input></div
                        ></el-col>
                        <el-col :span="15">
                            <el-button type="primary" icon="el-icon-search" @click="Search()">查询</el-button>
                            <el-button type="primary" icon="el-icon-plus" @click="addModal">新增</el-button>
                            <el-button type="primary" icon="el-icon-back" @click="goBack()">返回列表</el-button>
                        </el-col>
                    </el-row>
                    <el-table :data="tableData" style="width: 100%" border>
                        <el-table-column :resizable="false" type="index" label="序号" width="50">
                                <template slot-scope="scope">{{ scope.$index + 1 + searchInfo.pageSize * (searchInfo.pageNum - 1) }}</template>
                        </el-table-column>
                        <el-table-column :resizable="false" prop="couponName" label="优惠券名称" align="center"></el-table-column>
                        <el-table-column prop="couponMoney" label="优惠金额(￥)" :resizable="false" align="center"></el-table-column>
                        <el-table-column prop="couponPrice" label="售卖价格(￥)" :resizable="false" align="center"></el-table-column>
                        <el-table-column prop="expirationDate" label="有效期限" :resizable="false" align="center">
                            <template slot-scope="scope">
                                {{ scope.row.expirationDate == '-1' ? '无期限' : scope.row.expirationDate }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="sellNumber" label="已售数量" :resizable="false" align="center"></el-table-column>
                        <el-table-column label="状态" :resizable="false">
                            <template slot-scope="scope">
                                {{ scope.row.couponStatus == '0' ? '待上架' : '已上架' }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="createTime" label="创建时间" :resizable="false" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.createTime | moment('YYYY-MM-DD HH:mm:ss') }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="updateTime" label="更新时间" :resizable="false" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.updateTime | moment('YYYY-MM-DD HH:mm:ss') }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" :resizable="false" align="center">
                            <template slot-scope="scope">
                                <el-button v-if="scope.row.couponStatus == '0'"  @click="$refs.edit.getMerchantInfo({merchantId:id,id:scope.row.id})" type="text" size="small"
                                    >修改</el-button
                                >
                                <el-button @click="checkModal(scope.row)" type="text" size="small">查看</el-button>
                                <el-button v-if="scope.row.couponStatus == '0'" @click="deleteModal(scope.row)" type="text" size="small"
                                    >删除</el-button
                                >
                                <el-button v-if="scope.row.couponStatus == '0'" @click="upModal(scope.row)" type="text" size="small"
                                    >上架</el-button
                                >
                                <el-button v-if="scope.row.couponStatus == '1'" @click="downModal(scope.row)" type="text" size="small"
                                    >下架</el-button
                                >
                            </template>
                        </el-table-column>
                    </el-table>
                    <!-- 分页区域 -->
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="searchInfo.pageNum"
                        :page-size="searchInfo.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                    ></el-pagination>
                </el-card>
            </el-col>
        </el-row>
        <!-- 弹框 -->
        <el-dialog
            title="新增优惠券"
            :visible.sync="addDialogFormVisible"
            width="800px"
            :before-close="handleClose"
            :close-on-click-modal="false"
        >
            <add v-bind:addData="addData" @dialog="dialogForm" ref="add"></add>
        </el-dialog>
        <!-- <el-dialog title="修改优惠券" :visible.sync="editDialogFormVisible" width="800px" :close-on-click-modal="false">
            <edit v-bind:editData="editData" @dialogEdit="dialogFormEdit"></edit>
        </el-dialog> -->
             <edit ref="edit" @getSysInfoList="getSysInfoList"></edit>
    </div>
</template>
<script>
import add from './CouponChildren/add.vue';
import edit from './CouponChildren/edit.vue';
export default {
    data() {
        return {
            searchInput: '',
            // 查询参数
            searchInfo: {
                // 默认请求第一页
                pageNum: 1,
                // 默认请求10条数据
                pageSize: 10,
                couponName: '', //优惠券名称
                merchantId: ''
            },
            id: '', //商家id
            // 日期
            date: null,
            // 数据列表
            tableData: [],
            // 数据总数
            total: 0,
            addData: '',
            editData: {},
            addDialogFormVisible: false, //新增
            editDialogFormVisible: false //修改
        };
    },
    created() {
        // 获取数据列表
        console.log(this.$route.query);
        this.searchInfo.merchantId = this.$route.query.id;
        this.id = this.$route.query.id;
        console.log(this.id);

        this.getSysInfoList();
    },
    components: { add, edit },
    methods: {
        async getSysInfoList() {
            const res = await this.$axios.post('coupon/list', this.searchInfo);
            console.log(res);
            if (res.data.code == 0) {
                this.tableData = res.data.data;
                console.log(this.tableData);

                this.total = res.data.total;
            }
        },
        //查询
        Search() {
            this.searchInfo.pageNum = 1;
            this.getSysInfoList();
        },
        handleSizeChange(pageSize) {
            this.pageNum = 1;
            this.searchInfo.pageSize = pageSize;
            this.getSysInfoList();
        },
        handleClose() {
            this.$refs.add.resetForm();
            console.log(this.$refs.add.resetForm());
        },
        handleCurrentChange(pageNum) {
            this.searchInfo.pageNum = pageNum;
            this.getSysInfoList();
        },
        //新建
        addModal() {
            this.addData = this.id;
            console.log(this.addData);
            this.addDialogFormVisible = true;
        },
        //修改
        editModal(data) {
            this.editData.merchantId = this.id;
            this.editData.id = data.id;
            console.log(this.editData);
            this.editDialogFormVisible = true;
        },
        //删除
        deleteModal(data) {
            console.log(data);

            this.$confirm('您确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios
                    .post('coupon/delete', { id: data.id })
                    .then(res => {
                        if (res.data.code == 0) {
                            this.$message.success('删除成功');
                            this.getSysInfoList();
                        } else {
                            this.$message.error(res.data.data);
                        }
                    })
                    .catch(() => {
                        this.getSysInfoList();
                    });
            });
        },
        dialogFormEdit(data) {
            console.log(data);
            this.editDialogFormVisible = data;
            this.getSysInfoList();
        },
        dialogForm(data) {
            this.addDialogFormVisible = data;
            this.getSysInfoList();
        },
        //上架
        async upModal(data) {
            const res = await this.$axios.post('coupon/toPutShelf', {
                id: data.id
            });
            console.log(res);
            if (res.data.code == 0) {
                this.$message.success('上架成功');
                this.getSysInfoList();
            } else {
                this.$message.error(res.data.data);
            }
        },
        //下架
        async downModal(data) {
            const res = await this.$axios.post('coupon/toPublish', {
                id: data.id
            });
            console.log(res);
            if (res.data.code == 0) {
                this.$message.success('下架成功');
                this.getSysInfoList();
            } else {
                this.$message.error(res.data.data);
            }
        },
        checkModal(data) {
            this.$router.push({
                name: 'CouponCheck',
                query: {
                    id: data.id
                }
            });
        },
        goBack() {
            this.$router.push('/BusManage-Detail');
        }
    }
};
</script>
<style lang="less" scoped>
.el-table {
    margin-top: 20px;
}
.el-pagination {
    margin-top: 20px;
    text-align: center;
}
</style>
